import { render, staticRenderFns } from "./Contacts-table.vue?vue&type=template&id=661433ce"
import script from "./Contacts-table.vue?vue&type=script&lang=js"
export * from "./Contacts-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports